module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjQiIHZpZXdCb3g9IjAgMCA2IDQiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNlNzJjMzQ7CiAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBpZD0iXyIgZGF0YS1uYW1lPSImbHQ7IiBjbGFzcz0iY2xzLTEiIGQ9Ik04NjAsMjAybC0zLTRoNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04NTcgLTE5OCkiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-menu/arrow-bottom-red.svg
// module id = 818
// module chunks = 0